// extracted by mini-css-extract-plugin
export default {"Explanation":"Options_Explanation__TyneB","Options":"Options_Options__+-Ur3"};